// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__O+hIT","container":"Hero_container__HPuim","left":"Hero_left__R8AWv","badge":"Hero_badge__+lXCU","cta":"Hero_cta__BTciY","right":"Hero_right__vtTdj"};